import { StatusBadge } from '@/components/Common/StatusBadge/StatusBadge';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box } from '@mui/material';
import { CategoriesItemUi } from './CategoriesUi';

export const itemGenerator = (item: CategoriesItemUi) => {
  return [
    <>
      <Box>{item.categoryId}</Box>
    </>,
    <>
      <Box>{item.categoryName}</Box>
    </>,
    <>
      <Box>{item.categoryParent}</Box>
    </>,
    <>
      <Box>{item.categoryProductCount}</Box>
    </>,
    <>
      <Box>{item.status && <StatusBadge badge={item.status} />}</Box>
    </>,
    <MoreVertIcon />,
  ];
};
